import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { fmtMoney, fmtDate } from "../lib/format";
import { useActions } from "../components/ActionDialogs";
import { Button } from "../components/ui/button";
import { Plus, Receipt } from "lucide-react";

export default function Expenses() {
  const [expenses, setExpenses] = useState([]);
  const [clients, setClients] = useState({});
  const { open } = useActions();
  const navigate = useNavigate();

  const load = useCallback(() => {
    api.get("/expenses").then(({ data }) => setExpenses(data));
    api.get("/clients").then(({ data }) => { const m = {}; data.forEach((c) => (m[c.id] = c)); setClients(m); });
  }, []);
  useEffect(() => { load(); window.addEventListener("shb:refresh", load); return () => window.removeEventListener("shb:refresh", load); }, [load]);

  const cname = (id) => clients[id]?.name || "—";

  return (
    <div className="space-y-5 animate-in-up">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-navy-900">Masraflar</h1>
        <Button className="rounded-xl bg-navy-900 hover:bg-navy-800 text-white" data-testid="add-expense-btn" onClick={() => open("expense", { onDone: load })}>
          <Plus className="w-4 h-4 mr-1" /> <span className="hidden sm:inline">Masraf Ekle</span>
        </Button>
      </div>
      <div className="bg-white rounded-2xl border border-slate-200 p-5">
        {expenses.length === 0 ? <p className="text-sm text-slate-400 py-10 text-center">Masraf kaydı yok.</p> : expenses.map((e) => (
          <button key={e.id} onClick={() => navigate(`/muvekkiller/${e.client_id}`)} className="w-full flex items-center justify-between py-3 border-b border-slate-100 text-left hover:bg-slate-50 -mx-2 px-2 rounded-lg transition-colors">
            <div className="flex items-center gap-3 min-w-0">
              <span className="w-9 h-9 rounded-lg bg-amber-100 flex items-center justify-center shrink-0"><Receipt className="w-4 h-4 text-amber-700" /></span>
              <div className="min-w-0">
                <p className="text-sm font-medium text-navy-900 truncate">{e.category} · {cname(e.client_id)}</p>
                <p className="text-xs text-slate-400 truncate">{fmtDate(e.date)} · {e.description || ""}</p>
              </div>
            </div>
            <span className="font-mono text-sm font-semibold text-brand-red">−{fmtMoney(e.amount, e.currency)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
